<!-- Navbar.vue -->
<template>
  <div>
    <nav class="navbar">
      <div class="container">
        <div v-for="item in navigation" :key="item.to">
          <router-link  :to="item.to" class="nav-link" :class="{ active: activeLink === item.to }">{{ item.name| capitalizeFirst}}</router-link>
        </div>
      </div>
      <div class="float-right">
        <button class="logout-button" @click="logOut('¿Desea cerrar la sesión?', false)">Cerrar Sesión</button>
      </div>
    </nav>
    <logout-modal
    ></logout-modal>
  </div>
</template>

<script>
 import logoutModal from "./Modals/logoutModal.vue";
export default {
  components: {
    logoutModal,
    },
  data() {
    return {
      navigation: [],
      activeLink: '/' // Inicialmente el enlace activo es el de Inicio
    };
  },
  filters: {
    capitalizeFirst: function(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
  },
  watch: {
    $route(to) {
      this.activeLink = to.path; // Actualiza el enlace activo basado en la ruta actual
    }
  }, 
  methods:{
    async logOut(message, condition) {
      this.$store.state.Loading = false;
      if(!condition){
        const res = await this.$swal.fire({
          title: message,
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Cerrar',
          background: '#fff',
          backdrop: `
              rgba(0,0,123,0.4)
          `
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.removeItem("token");
                this.$router.push("/sas/login");
          }
        })
      }
      if(condition){
        const res = await this.$swal.fire({
        title: message,
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        allowOutsideClick: false,
        confirmButtonText: 'Cerrar',
        background: '#fff',
        backdrop: `
            rgba(0,0,123,0.4)
        `
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem("token");
              this.$router.push("/sas/login");
        }
      })
      }
    },
    async getRoutesAPI() {
      this.$store.state.token = localStorage.getItem("token");

      const payloadMenu = {
        metodo: "GETMENU",
        data: `idUser=${localStorage.getItem("profileId")}`,
      };

      try {
        const prom = await this.$store.dispatch("metodoPost", payloadMenu);
        if (prom) {
          const routes = this.$store.getters.getRespuestaREST;
          localStorage.setItem('idRol', routes._children[1]._idRol)
          console.log(routes._children[1]._idRol);
          Object.values(routes._children).forEach((item) => {
            if (item.route == "") delete item.route;
            if(item.to){
              if (item.name == "Inicio") item.to = '/sas/inicio';
              this.navigation.push(item)
            }
            // console.log(item);
          });
          // this.navigation = [routes];
          // console.log(this.navigation);
          this.$store.state.sidebarApps = this.navigation[0]._children;
          
          // this.navigation.map( routes => {
          //   console.log(routes);
          //   if(routes.to){
          //     console.log(routes);
          //   }
          // })

          // if (this.$store.state.sidebarApps.length == 0) {
          //   this.logOut("No tienes aplicaciónes asignadas", true);
          // }

          this.$store.state.Loading = false;
          return;
        }
      } catch (error) {
        this.logOut("Tu token ha expirado", true);
      }
    },
    validateUser(){
        const regex = /^[0-9]*$/;
        const onlyNumbers = regex.test(this.userId); // true
        if(onlyNumbers){
          //Es analista 
            this.mostrarAnalista = true
            this.mostrarProveedor = false
        } else {
          this.mostrarAnalista = false
            this.mostrarProveedor = true
        }
    },
},
mounted() {
    this.getRoutesAPI();
    this.validateUser();
  },
};
</script>

<style scoped>
.navbar {
  background-color: #f0f0f0; /* Fondo gris claro */
  padding: 22px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.container {
  display: flex;
  justify-content: center;
}

.nav-link {
  text-decoration: none;
  color: #333;
  padding: 10px 15px;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #085da8;
}

.nav-link.active {
  font-weight: bold;
  color: #2775b9;
}
.logout-button {
  border-top-left-radius: 9px;
  border-bottom-left-radius: 9px;
    background-image: linear-gradient(to right, #085da8, #003c71);
  color: white; 
  border: none;
  padding: 8px 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
</style>
